export default {
    AccountManagementAdd: {
        titile: 'Account Information',
        place: '2-20 Chinese/English/Numbers',
        name: 'Name',
        internationalTelCode: 'International Tel Code',
        phone: 'Phone',
        account: 'Account',
        Nickname: 'Nickname',
        password: 'Password',
        email: 'Email',
        sex: 'Gender',
        address: 'Region',
        Detailed: 'Detailed Address',
        Date: 'Date of Birth',
        ValidPS: 'The Valid Start Cannot Be Later Than The Valid End.',
        from: 'Valid From',
        until: 'Valid Until',
        Freeze: 'Freeze',
        Role: 'Role',
        Add: 'Add Role',
        RoleName: 'Role Name',
        TenantName: 'Department Name',
        Structure: 'Organizational Structure',
        ps: 'Please enter role name',
        ps1: 'Please enter name',
        ps2: 'Please select validity period',
        ps3: 'Please add a role for this account',
        ps4: 'Edit Account',
        ps5: 'Delete?',
        ps6: 'Role',
        ps7: 'Hint',
        ps8: 'Log',
        tips: "Please use ' ; ' for multiple email addresses separate",
        deptAbbr: 'Department Abbreviation',
        status: 'Current Status',
        onTime: 'Start Time Of Temporary Storage',
        offTime: 'End Time Of Temporary Storage',

      customerInfo: {
        industry: 'Industry Type',
        title: 'Account Information',
        clientCode: 'Customer Code',
        clientFullName: 'Customer Name',
        contactPerson: 'Customer Contact',
        companyName: 'Chinese Company Name',
        companyEnName: 'English Company Name',
        isNom: 'NET/EOM',
        paymentTerm: 'Days until Bill Due',
        ifLocal: 'Domestic Customer',
        currencySymbol: 'Currency',
        bpCode: 'Customer BP Code',
        billingAddress1: 'Customer Billing Address 1',
        billingAddress2: 'Customer Billing Address 2',
        billingAddressUnit: 'Customer Billing Address Apartment Number',
        billingAddressCity: 'Customer Billing Address City',
        billingAddressState: 'Customer Billing Address State',
        billingAddressCountry: 'Customer Billing Address Country',
        billingAddressPostcode: 'Customer Billing Address Postcode',
        billingAddressPhone: 'Customer Billing Address Phone',
        billingAddressEmail: 'Customer Billing Address Email',

        titile: 'Account Information',
        titile2: 'Customer Information',
        CSGSales: 'CSG Sales',
        CSGCustomerService: 'CSG Customer Service',
        CustomerType: 'Customer Type',
        ContactPerson: 'Contact Person ',
        ContactPhoneNumber: 'Contact Phone No.',
        CompanyInformation: 'Company Information',
        CompanyName: 'Company Name',
        GeneralEmail: 'General Email',
        generalEmailOther: 'Other General Email',
        BillEmail: 'Billing Email',
        BillEmailOther: 'Other Billing Email',
        FinancialEmail: 'Financial Email',
        CustomerServiceEmail: 'Customer Service Email',
        CustomerServiceEmailOther: 'Other Customer Service Email',
        CompanyAddress: 'Company Address',
        billingInformation: 'Billing Information',
        AccountingPeriod: 'Payment Term',
        CreditLimit: 'Credit Limit',
        billingAddress: 'Billing Address',
        abn: 'ABN',
        weburl: 'Web URL',
        MonthlySettlementTime: 'Monthly settlement time',
        userTip: 'Incorrect account or password, please try again or contact support.',
        palletAccount: 'Pallet Account',
        deposit: 'Deposit Amount'
      }
    }
};
